import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { FormHeaderText } from 'components/atoms';
import React from 'react';
import { IoMdClose } from 'react-icons/io';

import { BaseModalProps } from './types';

export const BaseModal = ({
  open,
  onClose,
  title,
  children,
  footer,
  maxWidth = 'lg',
}: BaseModalProps) => {
  return (
    <Dialog fullWidth={true} maxWidth={maxWidth} open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          paddingTop: 8,
        }}
      >
        <FormHeaderText gutterBottom>{title}</FormHeaderText>
        <IconButton aria-label="close" onClick={onClose} sx={{ marginRight: 5 }}>
          <IoMdClose />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      {footer ? (
        <DialogActions>{typeof footer === 'function' ? footer() : footer}</DialogActions>
      ) : null}
    </Dialog>
  );
};
